import React from "react";
import { connect } from "react-redux";
import _ from "lodash";

import { showToast, getData } from "Source/globalFunction";
import { Loading } from "Source/globalComponents";
import ProjectMemberForm from "../Member/Member";
import CalendarView from "../../Calendar/View/CalendarView";
import Inbox from "../../Inbox/Inbox";
import General from "../General/General";
import Workstreams from "../Workstreams/Workstreams";
import LongText from "Source/components/common/Elements/LongText/LongText";
import { FALLBACK_EMAIL } from "Source/components/project/Config/Config";
import { copyToClipboard } from "Source/util/navigator";
import Dashboard from "../../Dashboard/Dashboard";

@connect(store => {
    return {
        project: store.project,
        loggedUser: store.loggedUser,
        workstream: store.workstream,
        members: store.members,
        settings: store.settings
    };
})
export default class AccountView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ...this.state, // Preserve existing state properties
            hasChanges: {},
            onEdit: null,
            isOnEdit: null,
        };
        _.map([
            "renderStatus",
            "fetchWorkstreams",
            "getNextWorkstreams",
            "renderArrayTd",
            "handleEdit",
            "getMembers",
            "init",
            "handleEditChanges",
            "discardCancel",
            "triggerEdit",
        ], fn => {
            this[fn] = this[fn].bind(this);
        });
    }
    componentDidUpdate(prevProps) {
        if(prevProps.project.Selected && this.props.project.Selected
             && prevProps.project.Selected.id !== this.props.project.Selected.id) {
                this.init()
             }

    }
  componentDidMount(){
      this.init()
       
    }
         
    shouldComponentUpdate(nextProps){

        if(!_.isEqual(nextProps.scrollId, this.props.scrollId) && nextProps.scrollId) {
            if(this.refs[nextProps.scrollId]) {
                setTimeout(() => {
                    this.refs[nextProps.scrollId]?.scrollIntoView() 
                }, 100);
            }
        }
        return true
    }
    
    init(){
        this.getMembers();
        this.getProjectFormSelectList();
        this.fetchWorkstreams(1);
    }
    getMembers() {
        // TODO: For spring cleaning. 
        const { dispatch, project, projectId } = this.props;
        const projId = project.Selected.id || projectId;
        if (projId) {
            getData(`/api/projects/${projId}/members`, {}, c => {
                dispatch({ type: "SET_MEMBERS_LIST", list: c.data }); // new API returns array directly
                dispatch({ type: "SET_MEMBERS_LOADING", Loading: "" });
            });
        }
       
    }

    getProjectFormSelectList() { 
        const { dispatch } = this.props;
        getData(`/api/type`, {}, c => {
            dispatch({ type: "SET_TYPE_LIST", list: c.data });
            
        });
    }

    fetchWorkstreams(page) {
        
        const { dispatch, loggedUser, project, projectId} = this.props;
        const projId =  project.Selected.id || projectId
        if(projId) {
            const requestUrl = `/api/workstream?projectId=${projId}&page=${page}&userType=${loggedUser.data.userType}&userId=${loggedUser.data.id}&userRole=${loggedUser.data.userRole}&hasMembers=1&section=settings`;
            dispatch({ type: "SET_WORKSTREAM_LOADING", Loading: "RETRIEVING" });
            getData(requestUrl, {}, c => {
                if (c?.status === 200) {
                    if(page>1) {
                        dispatch({ type: "UPDATE_WORKSTREAM_LIST", list: c.data.result, Count: c.data.count });
                    } else {
                        dispatch({ type: "SET_WORKSTREAM_LIST", list: c.data.result, Count: c.data.count });
                    }
                } else {
                    showToast("error", "Something went wrong please try again later.");
                }
                dispatch({ type: "SET_WORKSTREAM_LOADING", Loading: "" });
            });
        }
       
    }
    getNextWorkstreams() {
        const { dispatch, workstream } = this.props;
        const { Count } = workstream;

        dispatch({ type: "SET_WORKSTREAM_LOADING", Loading: "RETRIEVING" });
        this.fetchWorkstreams(Count.current_page + 1);
    }

    renderStatus({ lateWorkstream, workstreamTaskDueToday, render_type }) {
        const status = lateWorkstream > 0 ? `${lateWorkstream} stream${lateWorkstream > 1 ? "s" : ""} delayed` : workstreamTaskDueToday > 0 ? `${workstreamTaskDueToday} stream${workstreamTaskDueToday > 1 ? "s" : ""} due today` : `On track`;
        const color = lateWorkstream > 0 ? "text-red" : workstreamTaskDueToday > 0 ? "text-yellow" : "text-green";
        const component = render_type === "text" ? <p class={`mb0 ${color}`}>{status}</p> : <span class={`fa fa-circle mb0 mr10 ${color}`} />;
        return component;
    }
    renderArrayTd(arr) {
        return arr.join("\r\n");
    }
    handleEdit() {
        const { dispatch } = this.props;
        dispatch({ type: "SET_PROJECT_FORM_ACTIVE", FormActive: "Form" });
    }

    handleEditChanges(param) {
        const obj = { ...this.state.hasChanges, ...param };
        this.setState({ hasChanges: obj });
    }

    discardCancel() {
        this.setState({ isOnEdit: this.state.onEdit });
        $('#accountSetting').modal("hide");
    }

    triggerEdit(param) {
        const [key, value] = Object.entries(param)[0];
        if (value !== undefined) {
            this.setState({ onEdit: key });
        }
    }

    render() {
        const { project, workstream, members, settings } = this.props;
        const { Selected } = project;
        const { project: projectName = "", workstream: workstreamList = [], type, color, projectManager = [], creator } = Selected;
        const workstreamCurrentPage = typeof workstream.Count.current_page !== "undefined" ? workstream.Count.current_page : 1;
        const workstreamLastPage = typeof workstream.Count.last_page !== "undefined" ? workstream.Count.last_page : 1;

        let lateWorkstream = 0;
        let workstreamTaskDueToday = 0;
        _.map(workstreamList, e => {
            if (e.taskOverDue.length) {
                lateWorkstream++;
            }
            if (e.taskDueToday.length) {
                workstreamTaskDueToday++;
            }
        });

        const isOpen = this.state.onEdit;

        return (
            <div class="row account-details-container">
                <div class="col-lg-12 pd0">
                    <div class="card form-card">
                        {/* <h4 class="settingsMainTitle"> Account Details</h4>  */}

                        <div class={project.Loading === "RETRIEVING" ? "linear-background" : ""}>
                            {projectName !== "" && project.Loading !== "RETRIEVING" && (
                                <div class="card-body viewOnly">
                                    <div ref='general'>
                                        <General />
                                    </div>

                                    <div ref='dashboard'>
                                        <Dashboard 
                                            editChange={this.handleEditChanges}  
                                            hasChanges={this.state.hasChanges}
                                            triggerEdit={this.triggerEdit}
                                            isEdit={this.state.isOnEdit}
                                            isOpen={isOpen}
                                            onCancel={() => { this.setState({ onEdit: null }); }}
                                        />
                                    </div>

                                    <div ref='inbox'>
                                       <Inbox />
                                    </div>

                                    <div ref='members'>
                                        <ProjectMemberForm />
                                    </div>
                                    
                                    <div ref='workstreams'>
                                        <Workstreams  />
                                    </div>

                                    <div ref='calendar'>
                                        <CalendarView ref="calendar" projectId={project.Selected.id} view={true} />
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
